import {
	Actions,
	Middleware
} from "@jsonforms/core";
import type Ajv from "ajv";
import isEqual from "lodash/isEqual";

import { AlternativeContext } from "./AlternativeContext";
import type {
	FormUiSchema,
	JsonSchemaDefinition
} from "./types";
import { VisibilityContext } from "./VisibilityContext";

/** Clear hidden values in core state, including fields in unopened row editors. */
export function createHiddenValuesMiddleware(
	schema: JsonSchemaDefinition,
	ui: FormUiSchema,
	ajv: Ajv,
	alternatives: AlternativeContext,
	onVisibility: (visibility: VisibilityContext) => void
): Middleware {
	return (state, action, reduce) => {
		let next = reduce(state, action);
		let changed = true;

		// Each pass only removes values. Reevaluate dependent rules until no more
		// values are removed; never restore a value when its control becomes visible.
		while(changed) {
			const visibility = new VisibilityContext(schema, next.data, ajv, ui, alternatives);
			onVisibility(visibility);
			const data = visibility.clearHiddenValues();

			changed = !isEqual(data, next.data);

			if(changed) {
				next = reduce(next, Actions.update("", () => data));
			}
		}

		return next;
	};
}
